import React, { useState, useEffect } from "react";
//引入frame框架antd
import Frame from "@/components/Frame";
import NewFrame from "@/components/NewFrame";
//引入路由
import { MenuRouter } from "@/router";
import "@/App.less";
import { Alert, ConfigProvider, message } from "antd";
import en_US from "antd/lib/locale-provider/en_US";
import zh_CN from "antd/lib/locale-provider/zh_CN";
import "moment/locale/zh-cn"; //不加这个切换中文时，日期组件年是中文，月是英文。。。。
import { BrowserRouter, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { uploadManager } from "@/store/uploadSlice";
import { abortAllPackets } from "@/services/dataPacket";
import { getVersion } from "@/utils/auth";
import { registerVoiceFactoryUnloadGuard } from "./utils/upload/voiceFactoryLifecycle.mjs";
//语言切换

export default function App() {
  const location = useLocation();
  const manager = useSelector(uploadManager);
  const [hasVoiceFactoryUploads, setHasVoiceFactoryUploads] = useState(
    () => manager.hasActiveVoiceFactoryUploads()
  );
  const [langType, setLangType] = useState(zh_CN);
  useEffect(() => {
    const removeGuard = registerVoiceFactoryUnloadGuard(manager);
    const removeStateListener = manager.on("VOICE_FACTORY_UPLOAD_STATE", setHasVoiceFactoryUploads);
    setHasVoiceFactoryUploads(manager.hasActiveVoiceFactoryUploads());
    const removeErrorListener = manager.on("VOICE_FACTORY_UPLOAD_ERROR", (payload) => {
      message.error({
        key: `voice-factory-upload-${payload.datasetId}`,
        content: `声优工厂上传失败${payload.filePath ? `（${payload.filePath}）` : ""}：${payload.error || "请在数据集详情中续传"}`,
        duration: 10,
      });
    });
    return () => {
      removeGuard();
      removeStateListener();
      removeErrorListener();
    };
  }, [manager]);
  //组件初始化获取获取指定验收报告列表
  useEffect(() => {
    setLangType(
      localStorage.getItem("language_type") === "en_US" ? en_US : zh_CN,
    );
    console.log(process.env.REACT_APP_BASE_URL, 4567);
    if (!process.env.REACT_APP_BASE_URL.includes('uat')) {
      // 本地 development 不调用 abortAllPackets
      if (
        process.env.NODE_ENV !== 'development' &&
        !location.pathname.includes('/login')
      ) {
        abortAllPackets();
      }
    } else {
      sessionStorage.setItem("dots-oldversion", "1");
    }

    return () => {
      manager.terminate(); // 清理
    };
  }, []);

  const version = getVersion();
  return (
    <ConfigProvider locale={langType}>
      {hasVoiceFactoryUploads && (
        <Alert
          className="voice-factory-upload-notice"
          type="warning"
          showIcon
          message="声优工厂数据上传中"
          description="正在校验或上传文件，请保持页面打开。上传完成后，本提示和离开确认会自动取消。"
        />
      )}
      <BrowserRouter>
        {version && (
          <Frame>
            <MenuRouter />
          </Frame>
        )}
        {!version && (
          <NewFrame>
            <MenuRouter />
          </NewFrame>
        )}
      </BrowserRouter>
    </ConfigProvider>
  );
}
